import { inject, Injectable } from '@angular/core'
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'
import { GalleryImage } from 'src/app/shared/interfaces/image-gallery/gallery-image.interface'
import { ImageGalleryModalComponent } from './image-gallery-modal/image-gallery-modal.component'

export interface ImageGalleryOptions {
    title?: string
    // Opens straight to this image's large view instead of the thumbnails
    startImageId?: number
}

@Injectable({
    providedIn: 'root',
})
export class ImageGalleryService {
    #modalService = inject(NgbModal)

    open(images: GalleryImage[], options: ImageGalleryOptions = {}): NgbModalRef {
        const modalRef = this.#modalService.open(ImageGalleryModalComponent, {
            size: 'xl',
            fullscreen: 'lg',
            scrollable: true,
            ariaLabelledBy: 'image-gallery-title',
            // The gallery handles Escape itself so it can step back from a large image to the thumbnails
            keyboard: false,
        })

        const gallery: ImageGalleryModalComponent = modalRef.componentInstance
        gallery.images.set(images)
        gallery.title.set(options.title ?? 'Images')
        gallery.selectedImageId.set(options.startImageId ?? null)

        return modalRef
    }
}
